module.exports = __webpack_public_path__ + "img/bj15.0038f2f8.png";